// 技能交換市集場次表資料（先寫死，之後有 API 再替換）
export const marketScheduleDays = [
  {
    year: 2026,
    month: '9',
    date: '12',
    weekday: '六',
    sessions: [
      { label: '場次 1', time: '10:00-12:30' },
      { label: '場次 2', time: '12:30-15:00' },
      { label: '場次 3', time: '15:00-17:30' },
      { label: '法師、義工場', time: '18:30-20:30' },
    ],
  },
  {
    year: 2026,
    month: '9',
    date: '13',
    weekday: '日',
    sessions: [
      { label: '場次 4', time: '07:30-10:00' },
      { label: '場次 5', time: '10:00-12:30' },
      { label: '場次 6', time: '12:30-15:00' },
    ],
  },
]

// 集章活動辦法：兌換條件
export const stampConditions = [
  {
    chipLabel: '一般\n集章',
    descParts: [
      { text: '集滿同一路線' },
      { text: '所有', highlight: true },
      { text: '攤位的認證章' },
    ],
  },
  {
    chipLabel: '混合\n集章',
    descParts: [
      { text: '持有' },
      { text: '兩張以上', highlight: true },
      { text: '學習地圖，累計集滿 ' },
      { text: '5個', highlight: true },
      { text: '認證章' },
    ],
  },
  {
    chipLabel: '座談會\n參與者',
    descParts: [
      { text: '憑' },
      { text: '識別證', highlight: true },
      { text: '及學習地圖，集滿 ' },
      { text: '3個', highlight: true },
      { text: '認證章' },
    ],
  },
]

// 集章活動辦法：兌換時間說明
export const redeemTimeParts = [
  { text: '每場次結束' },
  { text: '前20分鐘', highlight: true },
  { text: '至結束' },
  { text: '後10分鐘', highlight: true },
]

// 集章活動辦法：規則說明長圖（卡片堆疊，R1 在最上層）
export const marketRuleImages = [
  { id: 'R1', src: '/image/guardian-expo/r1.jpg', alt: '集章活動辦法說明 1' },
  { id: 'R2', src: '/image/guardian-expo/r2.jpg', alt: '集章活動辦法說明 2' },
  { id: 'R3', src: '/image/guardian-expo/r3.jpg', alt: '集章活動辦法說明 3' },
  { id: 'R4', src: '/image/guardian-expo/r4.jpg', alt: '集章活動辦法說明 4' },
  { id: 'R5', src: '/image/guardian-expo/r5.jpg', alt: '集章活動辦法說明 5' },
]
